// Expose jQuery globally. This must live in its own module: ES imports are
// hoisted, so an inline assignment in legacy.js would run *after* the plugin
// imports (jquery-ui, bootstrap, etc.) that reference the global `jQuery`.
import $ from 'jquery'
window.jQuery = window.$ = $
